import { MediaSection } from "../MediaSection";
import { MainImageSectionProps } from "./MainImageSection.props";
import "./MainImageSection.scss";

const MainImageSection = ({ src, className = "" }: MainImageSectionProps) => {
  return <MediaSection className={className} imageSource={src} />;
};

export default MainImageSection;
